import { ITeamMember } from "src/containers/teamMembers/useTeamMembersAPIHook";
import { SessionType } from "src/modules/interface";
import omit from "lodash/omit";

export const generateLogData = (
  sessionUserId: string,
  admin: SessionType["session"]["admin"],
  adminUserId: SessionType["session"]["adminUserId"],
  type: SessionType["session"]["type"],
  workplaceId: SessionType["session"]["profile"]["userId"],
  memberID?: string
) => {
  return {
    performedBy: admin ? adminUserId : sessionUserId,
    performedByType: admin ? "ADMIN" : type,
    workplaceId,
    ...(memberID && { performedOnUserId: memberID }),
  };
};

export const generateAddEditLogData = (
  userInfo: Partial<ITeamMember>,
  user: SessionType["session"]["user"],
  admin: SessionType["session"]["admin"],
  type: SessionType["session"]["type"],
  workplaceId: SessionType["session"]["profile"]["userId"],
  member?: ITeamMember
) => {
  const updateProperties = omit(userInfo, "alertSettings", "notify");
  const updatePropertiesKeys = Object.keys(updateProperties);
  const propertiesUpdated = updatePropertiesKeys.reduce((acc, property) => {
    acc[property] = {
      new: updateProperties[property],
    };
    if (member) {
      acc[property]["previous"] = member[property] ?? "";
    }
    return acc;
  }, {});

  if (propertiesUpdated["phone"]) {
    propertiesUpdated["mobilePhone"] = propertiesUpdated["phone"];
    delete propertiesUpdated["phone"];
  }

  return {
    performedBy: user?._id,
    performedByType: admin ? "ADMIN" : type,
    workplaceId,
    performedOnUserId: member?._id,
    propertiesUpdated,
  };
};

export const generateNotificationLogData = (
  property: string,
  existingData: string,
  updatedData: string,
  user: SessionType["session"]["user"],
  admin: SessionType["session"]["admin"],
  type: SessionType["session"]["type"],
  workplaceId: SessionType["session"]["profile"]["userId"],
  member?: ITeamMember
) => {
  return {
    performedBy: user?._id,
    performedByType: admin ? "ADMIN" : type,
    performedOnUserId: member?._id,
    workplaceId,
    [property]: {
      previous: existingData,
      new: updatedData.charAt(0).toUpperCase() + updatedData.slice(1),
    },
  };
};
